module.exports = __webpack_public_path__ + "static/media/second-login-bg.7472ae75.jpg";